<template>
  <div>
    <small class="caption">
      <strong>Contato</strong><br />
      {{ beneficiarioPinss ? beneficiarioPinss.operadoraSacTelefone : ""
      }}<br />
      {{ beneficiarioPinss ? beneficiarioPinss.operadoraSacSite : "" }}<br />
      www.unimed.coop.br<br />
      Ouvidoria:
      {{
        beneficiarioPinss ? beneficiarioPinss.operadoraOuvidoriaTelefone : ""
      }}
    </small>
  </div>
</template>

<script>
export default {
  name: "Beneficiario",
  props: {
    beneficiarioPinss: Object
  }
};
</script>

<style scoped lang="scss">
.pinss {
  p {
    margin-bottom: 8px;
  }
}
</style>
